module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('no-record', {
    attrs: {
      "condition": _vm.doctors,
      "tips": "没有找到医生信息"
    }
  }), _vm._v(" "), _c('ul', {}, _vm._l((_vm.doctors), function(item, index) {
    return _c('li', {
      staticClass: "arr-row",
      on: {
        "click": function($event) {
          return _vm.onSelectedDoctor(item, index, $event)
        }
      }
    }, [_c('div', {
      staticClass: "doctor-info"
    }, [_c('div', {
      staticClass: "head doc-header",
      style: ({
        backgroundImage: 'url(' + item.avatar + ')'
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "info"
    }, [_c('p', {
      staticClass: "f-large ellipsis"
    }, [_vm._v(_vm._s(item.rankName) + " " + _vm._s(item.doctName))]), _vm._v(" "), _c('p', {
      staticClass: "f-minor ellipsis",
      staticStyle: {
        "margin-top": "0.15rem"
      }
    }, [_vm._v(_vm._s(item.deptName))]), _vm._v(" "), _c('p', {
      staticClass: "f-minor ellipsis",
      staticStyle: {
        "margin-top": "0.15rem"
      }
    }, [_vm._v(_vm._s(item.doctDesc ? item.doctDesc : '暂无介绍'))])])])])
  }), 0)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7873ab72","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/doctinfo/DoctInfoList.vue
// module id = 860
// module chunks = 0